import { ComponentProps, Fragment, useEffect } from 'react';
import { VariantProps } from 'tailwind-variants';
import { Typography } from '../../molecules/Typography';
import { PaperContainer, ExerciseText, AnswerOpts } from './variants';
import PaperHeader from './components/header';
import { Colors } from '../../../models/disciplines';
import { usePrintComponentStore } from '../../organism/PrintComponent/store/usePrintComponentStore';

interface IExercisePaper
  extends VariantProps<typeof PaperContainer>,
    VariantProps<typeof ExerciseText> {
  iconType: 'material' | 'svg';
  icon: React.ComponentType<ComponentProps<'svg'>> | string;
  module: string;
  title: string;
  color: Colors;
}

const ExercisePaper: React.FC<IExercisePaper> = ({
  color,
  icon,
  iconType,
  module,
  title,
}) => {
  const { hasAnswerSheet, hasMoreExercises, numberOfColumns, data } =
    usePrintComponentStore();

  useEffect(() => {
    if (typeof window?.MathJax !== 'undefined' && data) {
      window.MathJax.typesetPromise();
    }
  }, [data]);

  const AnswerSheet = () => (
    <Fragment>
      <Typography type='title' size='h5' className='ml-4'>
        Gabarito
      </Typography>
      <div className={PaperContainer({ cols: 'split' })}>
        {data.length > 0 &&
          data.map((it: any, i: number) => (
            <div key={i} className='mb-5 flex flex-col gap-xs pr-5'>
              <Typography type='title' size='h6'>
                Exercício {i + 1}
              </Typography>
              {it.alternatives &&
                it.alternatives.map((alternative: any) => {
                  return (
                    alternative &&
                    alternative.correct && (
                      <span
                        key={`feedback-print-${alternative._id}`}
                        className={ExerciseText({
                          size: hasMoreExercises ? 'small' : 'default',
                        })}
                        dangerouslySetInnerHTML={{ __html: alternative.text }}
                      />
                    )
                  );
                })}
            </div>
          ))}
      </div>
    </Fragment>
  );

  return (
    <Fragment>
      <PaperHeader
        color={color}
        icon={{ icon, iconType }}
        module={module}
        title={title}
      />
      <div
        className={PaperContainer({
          cols: numberOfColumns as 'split' | 'single',
        })}
      >
        {data.length > 0 &&
          data.map((it: any, i: number) => (
            <div className='mb-5 flex flex-col gap-md pr-5' key={i}>
              <Typography type='title' size='h5'>
                Exercício {i + 1}
              </Typography>
              <div
                className={`text-mono-color-darkest ${ExerciseText({
                  size: hasMoreExercises ? 'small' : 'default',
                })}`}
                dangerouslySetInnerHTML={{ __html: it && it.statement }}
              />
              {it.alternatives && (
                <div>
                  {it.alternatives
                    .filter((choice: any) => choice && choice.text !== null)
                    .map(function (alternative: any) {
                      if (alternative) {
                        return (
                          <span
                            key={`alternative-print-${alternative._id}`}
                            className={`text-mono-color-darkest ${AnswerOpts({
                              size: hasMoreExercises ? 'small' : 'default',
                            })}`}
                            dangerouslySetInnerHTML={{
                              __html: alternative.text,
                            }}
                          />
                        );
                      }
                    })}
                </div>
              )}
            </div>
          ))}
      </div>
      {hasAnswerSheet && <AnswerSheet />}
    </Fragment>
  );
};

export default ExercisePaper;
